@if (!hideContent && additionalLinks) {
  <div class='additional-links-container'>
    <div><strong>Additional Links</strong></div>
    <div class='additional-links'>
      @for (link of additionalLinks; track link) {
        <div>
          <a target="_blank" [href]="link.url">{{ link.description }}</a>
        </div>
      }
    </div>
  </div>
}